import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './tailwind.css';
import './config/api'; // registers the axios auth interceptor

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);